import React from "react";

function ReasonField({ value, onChange, fieldName }) {
  return (
    <div className="form-group full-width">
      <label>Reason for {fieldName}:</label>
      <textarea
        style={{ maxWidth: "1300px" }}
        name="reason"
        placeholder="Enter your reason..."
        rows="3"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
      />
    </div>
  );
}

export default ReasonField;
